import React from 'react';
import Navbar from '../HomeComponents/Navbar';
import './ContactStyle.css';

export default function ContactPage() {
    return (
        <>
            <Navbar />
            <div className="main-container-contact">
                <div className="text-container-contact">
                    <h1 className="contact-heading">Join our community and unlock endless possibilities!</h1>
                    <p className="contact-text">Stay connected with us for the latest news, resources, and updates. Join our mailing list or follow us on social media to never miss out on important information.</p>
                </div>
                <div className="form-container">
                    <form action="https://formsubmit.co/webdevelopercode24@gmail.com" method="POST" className="form" autoComplete="off">
                        <h1 className="contact-main">Become a part of something great !!</h1>
                        <div className="names">
                            <input type="text" placeholder="First Name" className="input-name full-width input" name="First Name" required />
                            <input type="text" placeholder="Last Name" className="input-name full-width input" name="Last Name" required />
                        </div>
                        <div className="names">
                            <input type="number" min="8" max="12" placeholder="Enter Your Class from 8th to 12th" className="input-name full-width input" name="Class" required />
                            <input type="text" placeholder="Enter Your Subject" className="input-name full-width input" name="Subject" required />
                        </div>
                        <input type="hidden" name="_subject" value="New submission!" />
                        <input type="email" placeholder="Enter Your E-mail" className="input full-width" name="E-mail" required /> <br />
                        <input type="phone" placeholder="Enter Your Phone Number" className="input full-width" name="Number" required /> <br />
                        <textarea placeholder="Enter Your Message..." className="textarea" cols="30" rows="10" name="Message"></textarea> <br />
                        <input type="hidden" name="_captcha" value="false" />
                        <input type="hidden" name="_next" value="http://localhost:3000/thanks" />
                        <input type="hidden" name="_template" value="table" />
                        <button className="fancy" id="btnn">
                            <span className="top-key"></span>
                            <span className="text">Join Now</span>
                            <span className="bottom-key-1"></span>
                            <span className="bottom-key-2"></span>
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
}
